// A property lien's position (Debt page). Drives, once wired (Phase 2), the Loan
// Calculator's Current Loan Balance 1st/2nd/3rd TD and the CLTV/TLTV math.
export const FIRST_POSITION = "1";
export const SECOND_POSITION = "2";
export const THIRD_POSITION = "3";
export const OTHER_LIEN = "other";

export default Object.freeze({
  [FIRST_POSITION]: "1st Position",
  [SECOND_POSITION]: "2nd Position",
  [THIRD_POSITION]: "3rd Position",
  [OTHER_LIEN]: "Other Lien"
});
